export const generatedModelRunComparisonLedger = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-21T00:00:00.000Z",
  "mode": "deterministic-model-run-comparison-ledger",
  "operatingRule": "Every changed scenario conclusion must cite the baseline run hash, comparison run hash, rank deltas, utility deltas, replay contract, and commercial-use boundary.",
  "baseRunId": "run-hybrid-base-2026-06-19",
  "runCount": 3,
  "comparisonCount": 2,
  "selectedScenarioChangeCount": 2,
  "rankOneChangeCount": 0,
  "promotionAllowed": false,
  "commercialUseAllowed": false,
  "evidenceHashes": {
    "modelRunLedger": "sha256-23bb534c7980aa6ab7ba79b91f0d489e8f13deb5ed8999f3170c0c78030563c2",
    "baseRun": "sha256-584a64cb2fa258c8db87b6e31ef425771de1f617084c2e2fd1774832d7f4d207",
    "comparedRuns": "sha256-2245cc0e4ea884e2cba2cef2b0dbb131bdcbad247d3d22a5a3cbb52d76747316"
  },
  "comparisons": [
    {
      "id": "run-hybrid-base-2026-06-19__vs__run-conservative-moon-first-2026-06-19",
      "generatedAt": "2026-06-21T00:00:00.000Z",
      "mode": "model-run-comparison",
      "claimState": "model-derived-unvalidated",
      "baselineRun": {
        "id": "run-hybrid-base-2026-06-19",
        "label": "Hybrid base feasibility run",
        "runHash": "sha256-584a64cb2fa258c8db87b6e31ef425771de1f617084c2e2fd1774832d7f4d207",
        "selectedScenarioId": "hybrid",
        "rankOneScenarioId": "moon-first"
      },
      "comparisonRun": {
        "id": "run-conservative-moon-first-2026-06-19",
        "label": "Conservative Moon-first stress run",
        "runHash": "sha256-f58e6bfe5aae47d6d92365d8b83e1843a5dbf18a3fd82cad81824110d7346601",
        "selectedScenarioId": "moon-first",
        "rankOneScenarioId": "moon-first"
      },
      "selectedScenarioChanged": true,
      "rankOneChanged": false,
      "selectedScenarioDelta": {
        "baselineScenarioId": "hybrid",
        "comparisonScenarioId": "moon-first",
        "utilityDelta": 1.43,
        "businessReadinessDelta": 3.7,
        "capitalGapDeltaBn": 0,
        "selectedWinProbabilityDelta": 44.53
      },
      "biggestRankMover": {
        "scenarioId": "moon-first",
        "rankDelta": 0,
        "scenarioDeltaHash": "sha256-84c1670685e42218807e186e64491626049abf9148db06880e482dc6b0555f23"
      },
      "biggestUtilityMover": {
        "scenarioId": "moon-first",
        "utilityDelta": 0,
        "scenarioDeltaHash": "sha256-84c1670685e42218807e186e64491626049abf9148db06880e482dc6b0555f23"
      },
      "scenarioDeltas": [
        {
          "scenarioId": "moon-first",
          "name": "Moon-first Bootstrap",
          "baselineRank": 1,
          "comparisonRank": 1,
          "rankDelta": 0,
          "baselineUtility": 67.12,
          "comparisonUtility": 67.12,
          "utilityDelta": 0,
          "baselineUncertaintyPenalty": 8,
          "comparisonUncertaintyPenalty": 8,
          "uncertaintyPenaltyDelta": 0,
          "scenarioDeltaHash": "sha256-84c1670685e42218807e186e64491626049abf9148db06880e482dc6b0555f23"
        },
        {
          "scenarioId": "hybrid",
          "name": "Hybrid Moon -> Asteroid -> Mercury",
          "baselineRank": 2,
          "comparisonRank": 2,
          "rankDelta": 0,
          "baselineUtility": 65.69,
          "comparisonUtility": 65.69,
          "utilityDelta": 0,
          "baselineUncertaintyPenalty": 12,
          "comparisonUncertaintyPenalty": 12,
          "uncertaintyPenaltyDelta": 0,
          "scenarioDeltaHash": "sha256-2835e8d8f57effacb2c7e01907fa148a3781aa47098b0f0020392b607fd5498d"
        },
        {
          "scenarioId": "asteroid-first",
          "name": "Asteroid Feedstock-first",
          "baselineRank": 3,
          "comparisonRank": 3,
          "rankDelta": 0,
          "baselineUtility": 51.37,
          "comparisonUtility": 51.37,
          "utilityDelta": 0,
          "baselineUncertaintyPenalty": 18,
          "comparisonUncertaintyPenalty": 18,
          "uncertaintyPenaltyDelta": 0,
          "scenarioDeltaHash": "sha256-928b0d9ed6479355fefce2cd8c556dfa89cc162f003376dc9da398b0b2c4b9ce"
        },
        {
          "scenarioId": "mercury-orbit",
          "name": "Mercury Orbit-first",
          "baselineRank": 4,
          "comparisonRank": 4,
          "rankDelta": 0,
          "baselineUtility": 42.95,
          "comparisonUtility": 42.95,
          "utilityDelta": 0,
          "baselineUncertaintyPenalty": 24,
          "comparisonUncertaintyPenalty": 24,
          "uncertaintyPenaltyDelta": 0,
          "scenarioDeltaHash": "sha256-2e99967eacf9fae0c5d89eb94d2dc1fcc56f61aac4e76df06cff30336cd57679"
        },
        {
          "scenarioId": "mars-first",
          "name": "Mars-first Conventional Expansion",
          "baselineRank": 5,
          "comparisonRank": 5,
          "rankDelta": 0,
          "baselineUtility": 40.78,
          "comparisonUtility": 40.78,
          "utilityDelta": 0,
          "baselineUncertaintyPenalty": 12,
          "comparisonUncertaintyPenalty": 12,
          "uncertaintyPenaltyDelta": 0,
          "scenarioDeltaHash": "sha256-f2ab3890a19ddae5c506d2326a79b3fc4b838ccc073f95df17c3ba5b3e734858"
        },
        {
          "scenarioId": "mercury-polar",
          "name": "Mercury Polar Surface-first",
          "baselineRank": 6,
          "comparisonRank": 6,
          "rankDelta": 0,
          "baselineUtility": 37.95,
          "comparisonUtility": 37.95,
          "utilityDelta": 0,
          "baselineUncertaintyPenalty": 26,
          "comparisonUncertaintyPenalty": 26,
          "uncertaintyPenaltyDelta": 0,
          "scenarioDeltaHash": "sha256-37cc1058dd8367e4b7d5c1874e4c4f92cf5e8de484250f0f7427da9dc9032ba0"
        }
      ],
      "replayContract": {
        "state": "reproducible-from-model-run-ledger",
        "dependencyLedgerHash": "sha256-23bb534c7980aa6ab7ba79b91f0d489e8f13deb5ed8999f3170c0c78030563c2",
        "reproducibleCommand": "npm run science:run-comparisons",
        "verificationCommand": "node --test tests/model-run-comparison-ledger.test.mjs",
        "replayBoundary": "This compares deterministic model-run artifacts only. It does not promote external physics, economics, resource, or customer-use claims."
      },
      "decisionImpact": "Selected scenario changes under this run comparison; customer-facing conclusions must cite both run hashes and the changed assumptions.",
      "promotionAllowed": false,
      "commercialUseAllowed": false,
      "comparisonHash": "sha256-a4a89f96b3ec3e668f3b759bb5b75e72d86c3b85eb7cce142a3c9b7956fd7744"
    },
    {
      "id": "run-hybrid-base-2026-06-19__vs__run-asteroid-feedstock-probe-2026-06-19",
      "generatedAt": "2026-06-21T00:00:00.000Z",
      "mode": "model-run-comparison",
      "claimState": "model-derived-unvalidated",
      "baselineRun": {
        "id": "run-hybrid-base-2026-06-19",
        "label": "Hybrid base feasibility run",
        "runHash": "sha256-584a64cb2fa258c8db87b6e31ef425771de1f617084c2e2fd1774832d7f4d207",
        "selectedScenarioId": "hybrid",
        "rankOneScenarioId": "moon-first"
      },
      "comparisonRun": {
        "id": "run-asteroid-feedstock-probe-2026-06-19",
        "label": "Asteroid feedstock uncertainty probe",
        "runHash": "sha256-68cd75732797695c5aecb33617bd5132129608750a763e4c998d9e22bf4d1b22",
        "selectedScenarioId": "asteroid-first",
        "rankOneScenarioId": "moon-first"
      },
      "selectedScenarioChanged": true,
      "rankOneChanged": false,
      "selectedScenarioDelta": {
        "baselineScenarioId": "hybrid",
        "comparisonScenarioId": "asteroid-first",
        "utilityDelta": -14.32,
        "businessReadinessDelta": -12.4,
        "capitalGapDeltaBn": 0,
        "selectedWinProbabilityDelta": -26.95
      },
      "biggestRankMover": {
        "scenarioId": "moon-first",
        "rankDelta": 0,
        "scenarioDeltaHash": "sha256-84c1670685e42218807e186e64491626049abf9148db06880e482dc6b0555f23"
      },
      "biggestUtilityMover": {
        "scenarioId": "moon-first",
        "utilityDelta": 0,
        "scenarioDeltaHash": "sha256-84c1670685e42218807e186e64491626049abf9148db06880e482dc6b0555f23"
      },
      "scenarioDeltas": [
        {
          "scenarioId": "moon-first",
          "name": "Moon-first Bootstrap",
          "baselineRank": 1,
          "comparisonRank": 1,
          "rankDelta": 0,
          "baselineUtility": 67.12,
          "comparisonUtility": 67.12,
          "utilityDelta": 0,
          "baselineUncertaintyPenalty": 8,
          "comparisonUncertaintyPenalty": 8,
          "uncertaintyPenaltyDelta": 0,
          "scenarioDeltaHash": "sha256-84c1670685e42218807e186e64491626049abf9148db06880e482dc6b0555f23"
        },
        {
          "scenarioId": "hybrid",
          "name": "Hybrid Moon -> Asteroid -> Mercury",
          "baselineRank": 2,
          "comparisonRank": 2,
          "rankDelta": 0,
          "baselineUtility": 65.69,
          "comparisonUtility": 65.69,
          "utilityDelta": 0,
          "baselineUncertaintyPenalty": 12,
          "comparisonUncertaintyPenalty": 12,
          "uncertaintyPenaltyDelta": 0,
          "scenarioDeltaHash": "sha256-2835e8d8f57effacb2c7e01907fa148a3781aa47098b0f0020392b607fd5498d"
        },
        {
          "scenarioId": "asteroid-first",
          "name": "Asteroid Feedstock-first",
          "baselineRank": 3,
          "comparisonRank": 3,
          "rankDelta": 0,
          "baselineUtility": 51.37,
          "comparisonUtility": 51.37,
          "utilityDelta": 0,
          "baselineUncertaintyPenalty": 18,
          "comparisonUncertaintyPenalty": 18,
          "uncertaintyPenaltyDelta": 0,
          "scenarioDeltaHash": "sha256-928b0d9ed6479355fefce2cd8c556dfa89cc162f003376dc9da398b0b2c4b9ce"
        },
        {
          "scenarioId": "mercury-orbit",
          "name": "Mercury Orbit-first",
          "baselineRank": 4,
          "comparisonRank": 4,
          "rankDelta": 0,
          "baselineUtility": 42.95,
          "comparisonUtility": 42.95,
          "utilityDelta": 0,
          "baselineUncertaintyPenalty": 24,
          "comparisonUncertaintyPenalty": 24,
          "uncertaintyPenaltyDelta": 0,
          "scenarioDeltaHash": "sha256-2e99967eacf9fae0c5d89eb94d2dc1fcc56f61aac4e76df06cff30336cd57679"
        },
        {
          "scenarioId": "mars-first",
          "name": "Mars-first Conventional Expansion",
          "baselineRank": 5,
          "comparisonRank": 5,
          "rankDelta": 0,
          "baselineUtility": 40.78,
          "comparisonUtility": 40.78,
          "utilityDelta": 0,
          "baselineUncertaintyPenalty": 12,
          "comparisonUncertaintyPenalty": 12,
          "uncertaintyPenaltyDelta": 0,
          "scenarioDeltaHash": "sha256-f2ab3890a19ddae5c506d2326a79b3fc4b838ccc073f95df17c3ba5b3e734858"
        },
        {
          "scenarioId": "mercury-polar",
          "name": "Mercury Polar Surface-first",
          "baselineRank": 6,
          "comparisonRank": 6,
          "rankDelta": 0,
          "baselineUtility": 37.95,
          "comparisonUtility": 37.95,
          "utilityDelta": 0,
          "baselineUncertaintyPenalty": 26,
          "comparisonUncertaintyPenalty": 26,
          "uncertaintyPenaltyDelta": 0,
          "scenarioDeltaHash": "sha256-37cc1058dd8367e4b7d5c1874e4c4f92cf5e8de484250f0f7427da9dc9032ba0"
        }
      ],
      "replayContract": {
        "state": "reproducible-from-model-run-ledger",
        "dependencyLedgerHash": "sha256-23bb534c7980aa6ab7ba79b91f0d489e8f13deb5ed8999f3170c0c78030563c2",
        "reproducibleCommand": "npm run science:run-comparisons",
        "verificationCommand": "node --test tests/model-run-comparison-ledger.test.mjs",
        "replayBoundary": "This compares deterministic model-run artifacts only. It does not promote external physics, economics, resource, or customer-use claims."
      },
      "decisionImpact": "Selected scenario changes under this run comparison; customer-facing conclusions must cite both run hashes and the changed assumptions.",
      "promotionAllowed": false,
      "commercialUseAllowed": false,
      "comparisonHash": "sha256-e3ba912d138ed7037fb1fc55a6eedf0552a265d7e15e5c30d65966128e40d81a"
    }
  ],
  "ledgerHash": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d"
}
;
